import { PermissionType } from "./types";

export const consts: any = {




    EmailRegex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i,
    EmailEmployeeIDRegex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])|^[0-9]+$/i,
    LocationcodeAcceptableValueRegex: /^[a-zA-Z0-9" ,]*$/,
    LocationcodeLabelRegex: /^[a-zA-Z0-9 ]*$/,
    NumberRegex: /^[0-9\b]+$/,
    GooglePlaceAPIKey: 'AIzaSyA71xFIYIDJM1NZvIzW1aD9wqxcuGvUS48',
    //Production/UAT
    RecaptchaV2SiteKey: '6LcSpQ4aAAAAAJn9npkSdaPtHCPKyzfXMdGdYM83',
    //UAT (old key)
    //RecaptchaV2SiteKey: '6Lf8Z2IaAAAAAHCvilMMNFfVnHQssSWDzgFZsyOm',
    //New
    //RecaptchaV2SiteKey: '6Leo6vknAAAAAEdYokAOM0JlZyHT8hYtaBnwAoBz',
    //DataDog UAT
    DataDogDevUatApplicationId: '0cae2bc3-fece-4b7b-8055-6a8f6c5b121d',
    DataDogDevUatClientToken: 'pubd3eeb173cc6042d465cd6cc9c3951248',
    DataDogServiceName: 'sma-devuat',
    DataDogEnvName: 'dev',

    Permissions: {
        SMADriver: 'SMADriver',

        SMASuperUser: 'SMASuperUser',
        SMAAdminManageUsers: 'SMAAdminManageUsers',
        SMAAdminManageUserprofiles: 'SMAAdminManageUserprofiles',
        SMAAdminManageVehicles: 'SMAAdminManageVehicles',
        SMAAdminManageReasonsForDelay: 'SMAAdminManageReasonsForDelay',
        SMAAdminManageWards: 'SMAAdminManageWards',
        SMAAdminManageCustomers: 'SMAAdminManageCustomers',
        SMAAdminManageLocations: 'SMAAdminManageLocations',
        HospitalAdministrator: 'Hospital Administrator',
        SMAAdminViewSystemActivity: 'SMAAdminViewSystemActivity',
        SMAMakeBooking: "SMAMakeBooking",
        SMAEditBooking: "SMAEditBooking",
        SMAViewSchedule: 'SMAViewSchedule',
        SMAScheduleTransfer: 'SMAScheduleTransfer',
        SMAAdminPatientTransportDashboard: 'SMAAdminPatientTransportDashboard',
        SMAViewTransferHistory: "SMAViewTransferHistory",
        SMAManageRequestCallout: "SMAManageRequestCallout",
        SMARequestAdHocTransfer: "SMARequestAdHocTransfer",

        MakeBooking: 'MakeBooking',
        EditBooking: 'EditBooking',
        ViewSchedule: 'ViewSchedule',
        ManageUsers: 'ManageUsers',
        ManageUserprofiles: 'ManageUserprofiles',
        ManageCustomerVehicles: 'ManageCustomerVehicles',
        ScheduleTransfer: 'ScheduleTransfer',
        ViewDashboard: 'ViewDashboard',
        RequestCallout: "RequestCallout",
        RequestAdHocTransfer: "RequestAdHocTransfer",
        Addtransfers: "Add transfers",
        Removetransfers: "Remove transfers",
        Rescheduletrips: "Reschedule trips",
        Modifytripplansorderofstops: "Modify trip plans (order of stops)",
        Viewtransferlist: "View transfer list",
        Viewtransferdetailspage: "View transfer details page",
        AddtransfersSecondary: "Add transfers-Secondary",
        RemovetransfersSecondary: "Remove transfers-Secondary",
        RescheduletripsSecondary: "Reschedule trips-Secondary",     
        ModifytripplansorderofstopsSecondary: "Modify trip plans (order of stops)-Secondary",       
        ViewtransferlistSecondary: "View transfer list-Secondary",
        ViewtransferdetailspageSecondary: "View transfer details page-Secondary",
        SMAAddtransfers: "SMAAdd transfers",
        SMARemovetransfers: "SMARemove transfers",
        SMARescheduletrips: "SMAReschedule trips",
        SMAModifytripplansorderofstops: "SMAModify trip plans (order of stops)",
        SMAViewtransferlist: "SMAView transfer list",
        SMAViewtransferdetailspage: "SMAView transfer details page",
        SMAAddtransfersSecondary: "SMAAdd transfers-Secondary",
        SMARemovetransfersSecondary: "SMARemove transfers-Secondary",
        SMARescheduletripsSecondary: "SMAReschedule trips-Secondary",     
        SMAModifytripplansorderofstopsSecondary: "SMAModify trip plans (order of stops)-Secondary",       
        SMAViewtransferlistSecondary: "SMAView transfer list-Secondary",
        SMAViewtransferdetailspageSecondary: "SMAView transfer details page-Secondary",
        SubmitPatientCareRecord : "SubmitPatientCareRecords",
        SMASubmitPatientCareRecords : "SMASubmitPatientCareRecords",
        Primary:"Primary",
        Secondary:"Secondary",

        ViewCustomerTransferHistory: "ViewCustomerTransferHistory",
        CustomerDriver: 'CustomerDriver',

        ViewPCR: "ViewPCR",
        ReviewPCR: "ReviewPCR",
        CGReviewPCR: "CGReviewPCR",
        SMAAccessNurseStation: "SMAAccessNurseStation",
        AccessNurseStation: "AccessNurseStation",
        SMAViewPCR:"SMAViewPCR"
    },
    NewPermissions: {
        CreateUser: {
            PermissionType: PermissionType.Create,
            Table: "User",
        }
    },
    TransferStatus: {
        Requested: 1,
        ScheduledForTransport: 2,
        InProgress: 3,
        Complete: 4,
        AssignedToMe: 5,
        Aborted: 6,
        PickingUp: 7,
        EnRouteToDestination: 8,
        DroppingOff: 9,
        Ended: 10,
        Cancelled: 11,
        AdhocRequest : 13,
    },
    TransferStatusIndex:{
        1: "Requested",
        2: "ScheduledForTransport",
        3: "InProgress",
        4: "Complete",
        5: "AssignedToMe",
        6: "Aborted",
        7: "PickingUp",
        8: "EnRouteToDestination",
        9: "DroppingOff",
        10: "Ended",
        11: "Cancelled",
        13: "AdhocRequest",
    },

    GRAPH_COLORS: ["#4B753D", "#D89629", "#3724C6", "#984DAB", "#973636", "#6DC8FF", "#FFDC6D", "#3B5E84"],
    GRAPH_COLORS_BAR: ["#4E9E73", "#FFCE00", "#CC3D49", "#620707"],
    GRAPH_COLORS_BAR2: ["#3B5E84", "#6DC8FF", "#4B753D", "#984DAB", "#3724C6", "#D89629"],
    GRAPH_TIME: ["6AM - 8AM", "8AM - 10AM", "10AM - 12PM", "12PM - 2PM", "2PM - 4PM", "Other"],
    TermsLink: "https://www.statemedicalassistance.com.au/wp-content/uploads/2020/12/11050675_2-SMA-Live-Terms-of-Use-BP-14_12_20.pdf",
    PrivacyLink: "https://www.statemedicalassistance.com.au/sma-privacy-policy/",
    Customers:{
        SMA: "State Medical Assistance"
    }
}